import router from '@/router';
import store from '@/store';
import * as types from './types';
import api from '../../../api/login';
import auth from '../../../utils/auth';
import * as http from '../../../http';

export default {
  /**
   * Action which will check the authentication.
   *
   * @param {function} commit Commit function to update the store.
   */
  check({ commit }) {
    commit(types.CHECK);
  },

  loadInfos(context) {
    const queryString = {};
    const query = window.location.href.substr(window.location.href.indexOf('?') + 1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i += 1) {
      const pair = vars[i].split('=');
      // If first entry with this name
      if (typeof queryString[pair[0]] === 'undefined') {
        queryString[pair[0]] = decodeURIComponent(pair[1]);
        // If second entry with this name
      } else if (typeof queryString[pair[0]] === 'string') {
        const arr = [queryString[pair[0]], decodeURIComponent(pair[1])];
        queryString[pair[0]] = arr;
        // If third or later entry with this name
      } else {
        queryString[pair[0]].push(decodeURIComponent(pair[1]));
      }
    }

    if (queryString.token == null) {
      queryString.token = localStorage.getItem('userToken');
    } else {
      localStorage.setItem('userToken', queryString.token);
    }

    const infos = {
      authToken: queryString.token,
    };
    context.commit(types.LOAD_INFOS, infos);
  },

  login(context, searchParams) {
    store.dispatch('application/startLoading');
    return api.login(searchParams)
      .then((response) => {
        if (response.status === 200) {
          auth.setSession({
            token: response.headers['set-authorization'],
            login: response.data.data.login,
            orgId: response.data.data.userOrgId,
            fullName: `${response.data.data.firstName} ${response.data.data.name}`,
            features: response.data.data.features,
          });
          if (response.data.data.mustInitAccount) {
            auth.setSessionUserNeedFinalization(true);
          } else {
            auth.setSessionUserNeedFinalization(false);
          }
          if (auth.isLoggedIn()) {
            http.HTTP_ORGANIZATIONS.defaults.headers.common.Authorization = `Bearer ${auth.getSessionToken()}`;
            http.HTTP_CAMPAIGNS.defaults.headers.common.Authorization = `Bearer ${auth.getSessionToken()}`;
            http.HTTP_DESKRH.defaults.headers.common.Authorization = `Bearer ${auth.getSessionToken()}`;
            http.HTTP_USERS.defaults.headers.common.Authorization = `Bearer ${auth.getSessionToken()}`;
            http.HTTP_DOCUMENTS.defaults.headers.common.Authorization = `Bearer ${auth.getSessionToken()}`;
            router.push('/');
            if (auth.getOrgId()) {
              store.dispatch('organizations/getOrgConf', auth.getOrgId())
              .then((data) => {
                if (data.extraOptions.specificCSSUrl) {
                  const linkExternalStyle = document.createElement('link');
                  linkExternalStyle.type = 'text/css';
                  linkExternalStyle.rel = 'stylesheet';
                  linkExternalStyle.href = data.extraOptions.specificCSSUrl;
                  document.getElementsByTagName('head')[0].appendChild(linkExternalStyle);
                }
              });
            }
          }
          context.commit(types.AUTHENTIFICATION_SUCCESS);
        } else {
          context.commit(types.AUTHENTIFICATION_FAILED);
        }
        store.dispatch('application/finishLoading');
        return response;
      })
      .catch((data) => {
        store.dispatch('application/finishLoading');
        context.commit(types.AUTHENTIFICATION_FAILED);
        store.dispatch('application/openSnackbar', {
          message: `${data.response.data.data.errors}`,
        });
        return Promise.reject(data);
      });
  },

  setAuthorization() {
    http.HTTP_ORGANIZATIONS.defaults.headers.common.Authorization = `Bearer ${auth.getSessionToken()}`;
    http.HTTP_CAMPAIGNS.defaults.headers.common.Authorization = `Bearer ${auth.getSessionToken()}`;
    http.HTTP_DESKRH.defaults.headers.common.Authorization = `Bearer ${auth.getSessionToken()}`;
    http.HTTP_USERS.defaults.headers.common.Authorization = `Bearer ${auth.getSessionToken()}`;
    http.HTTP_DOCUMENTS.defaults.headers.common.Authorization = `Bearer ${auth.getSessionToken()}`;
  },

  logout(context) {
    context.commit(types.LOGOUT);
    auth.logout();
    delete http.HTTP_ORGANIZATIONS.defaults.headers.common.Authorization;
    delete http.HTTP_CAMPAIGNS.defaults.headers.common.Authorization;
    delete http.HTTP_DESKRH.defaults.headers.common.Authorization;
    delete http.HTTP_USERS.defaults.headers.common.Authorization;
    delete http.HTTP_DOCUMENTS.defaults.headers.common.Authorization;
    router.push('/login');
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js